import EntityService from '@/modules/common/services/entityService'
import Item from '@/modules/item/domain/Item'
import itemResource from '@/modules/item/service/itemResource'

const itemService = new EntityService<Item>(itemResource, Item)

export default itemService
